import { apiClient } from './client';
import { wpUploadImage, wpUploadImages } from './wordpress';
import type { ApiResponse, PageResponse } from '@/types/api';
import type { CreateProjectRequest, ProjectDTO, ProjectSummaryDTO } from '@/types/project';

export const projectsApi = {
  list(page = 0, size = 4, sort = 'lastModifiedDate,desc') {
    return apiClient.get<ApiResponse<PageResponse<ProjectSummaryDTO>>>('/api/projects', {
      params: { page, size, sort },
    });
  },

  listPublic(page = 0, size = 100, sort = 'lastModifiedDate,desc') {
    return apiClient.get<ApiResponse<PageResponse<ProjectSummaryDTO>>>('/api/public/projects', {
      params: { page, size, sort },
    });
  },

  getById(id: number) {
    return apiClient.get<ApiResponse<ProjectDTO>>(`/api/projects/${id}`);
  },

  getPublicById(id: number) {
    return apiClient.get<ApiResponse<ProjectDTO>>(`/api/public/projects/${id}`);
  },

  create(data: CreateProjectRequest) {
    return apiClient.post<ApiResponse<ProjectDTO>>('/api/projects', data);
  },

  update(id: number, data: CreateProjectRequest) {
    return apiClient.put<ApiResponse<ProjectDTO>>(`/api/projects/${id}`, data);
  },

  delete(id: number) {
    return apiClient.delete<void>(`/api/projects/${id}`);
  },

  /** Upload a single image to WordPress and return the URL */
  async uploadImage(file: File): Promise<string> {
    return wpUploadImage(file);
  },

  /** Upload multiple images to WordPress and return the URLs */
  async uploadImages(files: File[]): Promise<string[]> {
    return wpUploadImages(files);
  },
};
